export const FETCH_LIST_STAFF_REQUEST= "FETCH_LIST_STAFF_REQUEST";
export const FETCH_LIST_STAFF_SUCCESS= "FETCH_LIST_STAFF_SUCCESS";
export const FETCH_LIST_STAFF_FAILURE= "FETCH_LIST_STAFF_FAILURE";

// View single staff
export const FETCH_STAFF_REQUEST= "FETCH_STAFF_REQUEST";
export const FETCH_STAFF_SUCCESS= "FETCH_STAFF_SUCCESS";
export const FETCH_STAFF_FAILURE= "FETCH_STAFF_FAILURE";





// Add staff
export const ADD_STAFF_REQUEST = "ADD_STAFF_REQUEST";
export const ADD_STAFF_SUCCESS = "ADD_STAFF_SUCCESS";
export const ADD_STAFF_FAILURE = "ADD_STAFF_FAILURE";

// Edit staff
export const UPDATE_STAFF_REQUEST= "UPDATE_STAFF_REQUEST";
export const UPDATE_STAFF_SUCCESS= "UPDATE_STAFF_SUCCESS";
export const UPDATE_STAFF_FAILURE= "UPDATE_STAFF_FAILURE";

// Delete staff
export const DELETE_STAFF_REQUEST= "DELETE_STAFF_REQUEST";
export const DELETE_STAFF_SUCCESS= "DELETE_STAFF_SUCCESS";
export const DELETE_STAFF_FAILURE= "DELETE_STAFF_FAILURE";

// Reset current staff
export const RESET_CURRENT_STAFF= "RESET_CURRENT_STAFF";

export const HISTORY_STAFF_REQUEST="HISTORY_STAFF_REQUEST";
export const HISTORY_STAFF_SUCCESS="HISTORY_STAFF_SUCCESS";
export const HISTORY_STAFF_FAILURE="HISTORY_STAFF_FAILURE";